module.exports = __webpack_public_path__ + "img/logo-300x297.4983b15e.png";